import { Component, ViewChild, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/services/error-handler.service'
import { HttpService } from '../../shared/services/http.service'
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../../dialog/dialog.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'request-add',
    template: require('./foc-create.component.html'),
    styles: [require('./foc-create.component.scss')],
    providers: [HttpService, ErrorHandler,SessionHandler]
})

export class FOCviewRequestAddComponent {

    dialogRef;
    requestOrder:any;
	id:any;	
    userData:any;
    tradeData:any = {};
    formData:any;
    uploadedDocList:any=[];
    contactList: any;
    isAnyChanged:boolean=false;
    showingMediaErrorMsg:any;
    showingmediaError:any;
    returnOrderId:any;
    data: any;
    hideUpdateButton: any;
    isD2cUser=false;
	constructor(private router: Router,private route: ActivatedRoute,private http:HttpService,private commonService : CommonService,
    private sessionHandler:SessionHandler,public dialog: MdDialog) {
        console.log("####")

        this.requestOrder = {};
        this.userData = {};
        if(this.http.checkSession()){
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.route.params.subscribe(params => {
                this.id = +params['id'];
            });
            let data = this.commonService.getData();
            if(this.userData){
                if(!isNaN(this.id)){
                    console.log("####")
                    this.getRequestDataWithId();
                   
                }
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() {

        console.log("####")

    }

    public getTradeData(id){
        this.http.getRequest('tradePartnerDetails/v1/get?tradePartnerId='+ id)
        .subscribe(
            res => {
                this.saveTradeData(res)
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
        });
    }
    
    public saveTradeData(res) {
        if(res.status == "Success") {
            this.tradeData = res.tradePartner;
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to fetch trade data.';
        }
        this.http.onEnd();
    }

    public getRequestDataWithId() {
        console.log("####")
        this.http.getRequest('focApi/v1/getFOCRequestDetail?FOCId='+ this.id)
        .subscribe(
            res => {this.saveRequestData(res)
                console.log("####")
            },
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = err;

                }
                this.http.onEnd();
        });        
    }

    public saveRequestData(res){
        if(res.status == 'Success'){
            this.requestOrder = res.FOCRequestDetail;  
           
            this.formData = res.FOCRequestDetail;
            console.log("ship to", this.formData);
            this.getTradeData(this.formData.soldTo);
            this.commonService.changeViewData(this.formData);
            res.FOCRequestDetail['status']=="REJECTED_FOR_INCOMPLETENESS"?this.hideUpdateButton=true:this.hideUpdateButton=false;
            console.log(this.hideUpdateButton);
            this.returnOrderId=
            {
                transactionId:res.FOCRequestDetail.sapFOCNo
            }
            this.imageShow(this.returnOrderId);     //Call ServiceDoc Api
          
            // this.getContactList('new');
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Could not load data for this request.';
            this.http.onEnd();
        }
        // this.http.onEnd();
    }

    imageShow(data){
        this.http.showLoader();
        this.http.downloadPostRequest('document/downloadDocument',data).subscribe(
          res => {
            this.sanitizeUrl(res['data'])
            this.http.onEnd();
        },
         err => {
            this.http.onEnd();
           this.showingMediaErrorMsg ="error in fetch image data";
           this.showingmediaError =true;
         }
        );   
    }
    sanitizeUrl(data){

        this.uploadedDocList =data;
        console.log("uploaded docs,",this.uploadedDocList);
    }
    


    public goToNextPage() {
       this.commonService.setData(this.formData);
       this.router.navigateByUrl('/app/foc-view/return/'+this.id);
       
    }

    public navigateDocLink(docUrl){    
        this.dialogRef = this.dialog.open(FOCviewDialog);
        this.dialogRef.componentInstance.urlList = docUrl;
        this.http.onEnd();
    }

    //     public getContactList(action = null) {
    //     let tradeId;
    //     tradeId=this.formData.tradePartnerId;
    //     this.http.getRequest('userOperationsApi/v1/getContacts?tradePartnerId=' + tradeId)
    //         .subscribe(
    //             res => { this.saveContactList(res, action) },
    //             err => {
    //                 if(err && err.status!=0){
    //                     this.dialogRef = this.dialog.open(dialogComponent);
    //                     this.dialogRef.componentInstance.msg = err;

    //                 }
    //                 this.http.onEnd();
    //             });
    // }
    // public saveContactList(res, action) {
    //     this.contactList = res.items;
    //     this.http.onEnd();
    // }

    updateContractDetail(){
        // if(this.isD2cUser){/**Added for d2c user sold to */
        //     this.formData.requestOrder.tpDetails['soldTo']=this.tradeData.name1
        // }
        this.http.postRequest(this.formData,'returnOrder/v1/updateReturnOrder')
            .subscribe(
                (res:any) => { 
                    if(res.status.toLowerCase()!='error'){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = "Successfully updated.";
                        this.http.onEnd();
                    }else{
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg =res.errorMessage||"Failed to process request. Please contact administrator.";
                        this.http.onEnd();
                    }

                 },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
   
    }

    selectChanged(){
        this.isAnyChanged=true;
    }

    
}


// view open dialog

@Component({
    template: require('./foc-view.component.html'),
    providers: [HttpService,SessionHandler]
})
export class FOCviewDialog implements OnInit {
    //url: string = "https://storage.googleapis.com/kitchenaid-web-return-dev.appspot.com/ReturnUploadedDocs/challan_receipt.pdf";
    urlSafe: SafeResourceUrl;
    urlList :any = [];
    safeUrlList :any = [];
    constructor(public dialog: MdDialog,private commonService : CommonService, public sanitizer: DomSanitizer){
        
    }
    ngOnInit(): void {
        //this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
       
    }

    public fullView(docUrl){
        window.open(docUrl, "_blank");
    }

    public closeDialog(){
        this.dialog.closeAll();
    }

    
}
   




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/FOCviewRequest/foc-create/foc-create.component.ts